var map = {
	"./arrow_right.svg": 1089,
	"./bag.svg": 1091,
	"./caret_down.svg": 1092,
	"./chevron_down.svg": 1093,
	"./chevron_down_small.svg": 1094,
	"./chevron_left.svg": 1095,
	"./chevron_right.svg": 1096,
	"./chevron_up.svg": 1097,
	"./chevron_up_small.svg": 1098,
	"./close.svg": 1099,
	"./heart.svg": 1100,
	"./info-filled.svg": 1101,
	"./search-no-results.svg": 1102,
	"./search.svg": 1103,
	"./social-logo/apple.svg": 1104,
	"./social-logo/facebook.svg": 1105,
	"./social-logo/google.svg": 1106,
	"./stone-shape/asscher.svg": 1107,
	"./stone-shape/baguette.svg": 1108,
	"./stone-shape/cushion.svg": 1109,
	"./stone-shape/emerald.svg": 1110,
	"./stone-shape/heart.svg": 1111,
	"./stone-shape/marquise.svg": 1112,
	"./stone-shape/oval.svg": 1113,
	"./stone-shape/pear.svg": 1114,
	"./stone-shape/princess.svg": 1115,
	"./stone-shape/radiant.svg": 1116,
	"./stone-shape/round.svg": 1117,
	"./stone-shape/tapered-baguette.svg": 1118,
	"./stone-shape/triangle.svg": 1119,
	"./stone-shape/trillion.svg": 1120,
	"./tag.svg": 1121,
	"./truck.svg": 1122,
	"./user.svg": 1123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1088;